<div class="analytics-card">
  <div class="analytics-card-header">
    <h3 class="title">{{ title }}</h3>
    <div class="analytics-card-utils">
      @if (infos) {
        <app-info-popover [text]="infos" />
      }
      @if (exportable) {
        <div class="export-button-container">
          <ng-content select="[export-button]"></ng-content>
        </div>
      }
    </div>
  </div>
  <div class="analytics-card-content">
    <ng-content></ng-content>
  </div>
</div>
